"use client"

import Image from "next/image"
import { ChevronRight, Home } from "lucide-react"

const BannerSectionThird = () => {
    const fontStyle = { fontFamily: '"Plus Jakarta Sans", sans-serif' }

    return (
        <section className="relative w-full bg-white">

            {/* Animation */}
            <style dangerouslySetInnerHTML={{
                __html: `
                @keyframes bounce-horizontal {
                    0%, 100% { transform: translateX(0); animation-timing-function: cubic-bezier(0.8, 0, 1, 1); }
                    50% { transform: translateX(-25%); animation-timing-function: cubic-bezier(0, 0, 0.2, 1); }
                }
            `}} />

            {/* Container */}
            <div className="relative w-full px-4 md:px-6 xl:px-8 2xl:px-12 min-[1920px]:px-16">

                {/* Banner */}
                <div className="relative w-full h-[280px] md:h-[360px] xl:h-[420px] 2xl:h-[550px] min-[1920px]:h-[750px] rounded-2xl overflow-hidden group">

                    {/* Ảnh nền */}
                    <Image
                        src="/images/logistic/xetai.png"
                        alt="Rovi Logistic Banner"
                        fill
                        className="object-cover"
                        priority
                    />

                    {/* Overlay */}
                    <div className="absolute inset-0 bg-black/20" />

                    {/* Breadcrumb */}
                    <div
                        className="hidden md:flex absolute top-2 left-2 xl:top-4 xl:left-4 2xl:top-5 2xl:left-5 min-[1920px]:top-8 min-[1920px]:left-8 items-center gap-1 text-white z-20"
                        style={fontStyle}
                    >
                        <Home className="size-3 xl:size-3.5 2xl:size-4 min-[1920px]:size-5" strokeWidth={2} />
                        <ChevronRight className="size-2.5 xl:size-3 2xl:size-3.5 min-[1920px]:size-4 opacity-70" />
                        <span className="text-[10px] xl:text-xs 2xl:text-[13px] min-[1920px]:text-base font-light tracking-wide">
                            Rovi Logistic
                        </span>
                    </div>

                </div>

                {/* Chỉ báo cuộn */}
                <div className="hidden md:block absolute bottom-30 right-0 -translate-x-1 -rotate-90 origin-bottom-right z-12 2xl:right-2 min-[1920px]:right-4 min-[1920px]:bottom-40">
                    <div className="flex items-center gap-2 text-black/60">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1"
                            stroke="currentColor"
                            className="w-5 h-5 2xl:w-6 2xl:h-6 min-[1920px]:w-8 min-[1920px]:h-8"
                            style={{ animation: "bounce-horizontal 1s infinite" }}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                        </svg>
                        <p className="font-normal tracking-[0.12em] text-[10px] 2xl:text-xs min-[1920px]:text-sm uppercase whitespace-nowrap">
                            Scroll Down
                        </p>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default BannerSectionThird